module.exports = __webpack_public_path__ + "static/media/5import-7.1c6be263.xlsx";